import { toast } from 'react-toastify';
import { Api } from './interface';
import { useIdleTimer } from 'react-idle-timer';

let oktaKeys = [];
let oKeys = [];

const minHeight = (pageNo, rowsPerPage, totalRows) => {
  let endOfPage = (pageNo + 1) * rowsPerPage;
  if (totalRows < endOfPage) {
    let diff = rowsPerPage - (endOfPage - totalRows);
    return diff <= 5 ? false : true;
  } else {
    return true;
  }
};

const formatHistoryResponse = (response) => {
  let metadata = {};

  return response.map((entry) => {
    entry.EntityMetaType =
      entry.EntityMetaType === 'EntityStatus' ? 'Status' : entry.EntityMetaType;
    entry.EntityMetaValue =
      entry.DataType === 'Binary'
        ? entry.EntityMetaValue === '1'
          ? 'True'
          : 'False'
        : entry.EntityMetaValue;
    entry.EntityMetaValue = entry.EntityMetaValue || '(blank)';
    let type = entry.EntityMetaType;
    let value = entry.EntityMetaValue;
    if (type) {
      entry.PrevEntityMetaValue = metadata[type] || '';
      metadata[type] = value;
    }
    return entry;
  });
};

const handleResize = () => {
  // resize the tab-container elements on resizing window
  let elements = document.querySelectorAll("[id='tab-container']");
  if (elements?.length) {
    elements.forEach((element) => {
      let bounds = element.getBoundingClientRect();
      let top = bounds.top; // table top position from window top
      let height = bounds.height; // table height
      let totalHeight = top + height + 70; // 70px is the footer of the table
      let windowHeight = window.innerHeight;
      // add dynamic height if data is present
      if (windowHeight <= totalHeight) {
        let diff = totalHeight - windowHeight;
        element.style.height = '' + (height - diff) + 'px';
      } else {
        if (windowHeight - totalHeight >= 30) {
          let diff = windowHeight - totalHeight;
          element.style.height = '' + (height + diff) + 'px';
        }
      }
    });
  }
  // if data not found for tableContainer elements, set height to 20% innerHeight
  elements = document.querySelectorAll("[id='tableContainer']");
  if (elements?.length) {
    elements.forEach((element) => {
      element.style.removeProperty('height'); // remove height if set
      element.classList.add('tableContainerResize'); // add class to set fixed height if no data ti display on resize
    });
  }
};

const isNum = (val) => {
  return !isNaN(val);
};

const uploadError = (row, val, type, format) => {
  return (
    'Row Num : ' +
    (row + 1) +
    ' - ' +
    val +
    ' is not a valid value/format for ' +
    type +
    '. Expected Format : ' +
    format
  );
};

const groupSelectError = (row, val, type) => {
  return (
    'Row Num : ' +
    (row + 1) +
    ' - ' +
    val +
    ' is not a valid option for ' +
    type
  );
};

const toastMsg = (val, item) => {
  return item.DataType === 'Binary'
    ? val
      ? 'True'
      : 'False'
    : val.length
      ? val
      : '(Blank)';
};

const extractValue = (obj, orderBy) => {
  let value = obj[orderBy];
  if (Array.isArray(value)) {
    return value[0].toLowerCase();
  } else if (typeof value === 'string') {
    return value.toLowerCase();
  } else if (typeof value === 'undefined') {
    return null;
  } else if (value === '') {
    // check if value is an empty string
    return '\uffff'; // return a value larger than any other value
  } else {
    return value;
  }
};

const descendingComparator = (a, b, orderBy) => {
  let aValue = extractValue(a, orderBy);
  let bValue = extractValue(b, orderBy);

  if (aValue != null) {
    aValue = isNum(parseInt(aValue, 10))
      ? parseInt(aValue, 10)
      : aValue.toString();
  }

  if (bValue != null) {
    bValue = isNum(parseInt(bValue, 10))
      ? parseInt(bValue, 10)
      : bValue.toString();
  }

  return (
    (aValue === null) - (bValue === null) ||
    -(aValue > bValue) ||
    +(aValue < bValue)
  );

  // return bValue < aValue ? -1 : bValue > aValue ? 1 : 0;
};

const getComparator = (order, orderBy) => {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
};

const isJson = (str) => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};

const clearCookies = () => {
  getOktaKeys(); // backup of okta keys
  // remove any fields, filters, orders
  localStorage.clear();
  setOktaKeys(); // setting back okta keys to local storage

  toast.success('Cache cleared successfully');
};

const getOktaKeys = () => {
  oktaKeys = [];
  oKeys = [];

  for (let key in localStorage) {
    if (key.includes('okta')) {
      oKeys.push(key);
      let obj = {};
      obj[key] = localStorage.getItem(key);
      oktaKeys.push(obj);
    }
  }
};

const setOktaKeys = () => {
  for (let obj in oktaKeys) {
    let key = oKeys[obj];
    let object = oktaKeys[obj];
    localStorage.setItem(oKeys[obj], object[key]);
  }
};

const getRoles = (setRoleFlag) => {
  let user = bake({ key: 'user' });
  Api({
    sp: 'getRolesByUser',
    json: { user: user.oid },
  }).then((response) => {
    bake({ key: 'roles', value: response });
    if (setRoleFlag) {
      setRoleFlag(true);
    }
    return response;
  });
};

const checkVersion = () => {
  Api({ sp: 'getVersion', json: {} }).then((response) => {
    bake({ key: 'version', value: response[0].Version });
  });
};

const getEnvironment = () => {
  // Determine environment based on current URL
  const hostname = window.location.hostname;

  const currentEnv = hostname.includes('elm.solidapps.net')
    ? 'PROD'
    : hostname.includes('elm-qa.solidapps.net')
      ? 'QA'
      : 'DEV';

  return currentEnv;
};

const setEnvironmentVariables = () => {
  // Get all environment variables
  Api({
    sp: 'getEnvironmentVariables',
    json: { environment: getEnvironment() },
  }).then((response) => {
    // Loop through each env variable and set a cookie
    response.forEach((x) => {
      bake({ key: x.Variable, value: x.Value });
    });
  });
};

const getNextSteps = (workflow, step) => {
  Api({
    sp: 'getNextWorkflowSteps',
    json: { workflow: workflow, step: step() },
  }).then((response) => {
    return response;
  });
};

const isObj = (str) => {
  if (typeof str === 'object') {
    return true;
  }
  return false;
};

const bake = (obj) => {
  // if props are passed in obj, the key is not global
  // if props are not passed in obj, the key is global
  let props = obj.props ?? null;
  let key = obj.key;
  let global = props ? false : true;

  return oven(props, global, key, obj.value);
};

const oven = (props, global, key, value) => {
  let level = props?.level ?? '';
  level = props?.myHomePage ? 'myHomePage-' + level : level;
  const type = props?.type ?? '';
  const suffix = global ? '' : '-' + level + '-' + type;
  if (value || value === '') {
    localStorage.setItem(
      key + suffix,
      isObj(value) ? JSON.stringify(value) : value
    );
  } else {
    const item = localStorage.getItem(key + suffix);
    return isJson(item) ? JSON.parse(item) : item;
  }
};

const clearStorage = (props, c) => {
  const level = props.level ?? '';
  const type = props.type ?? '';
  const suffix = '-' + level + '-' + type;
  localStorage.removeItem(c + suffix);
};

/**
 * @param onIdle - function to notify user when idle timeout is close
 * @param idleTime - number of seconds to wait before user is logged out
 */
const idleTimeout = ({ onIdle, idleTime = 1, handleIdle }) => {
  const idleTimeout = 1000 * idleTime;

  const idleTimer = useIdleTimer({
    timeout: idleTimeout,
    promptTimeout: idleTimeout / 2,
    onPrompt: onIdle,
    onIdle: handleIdle,
    debounce: 500,
  });
  return {
    idleTimer,
  };
};

const excelDateToJSDate = (excelSerial) => {
  // Excel's epoch starts on January 1, 1900 - Subtract 1 because Excel considers 1/0/1900 as January 1, 1900
  // Subtract another day for Excel's leap year bug (1900 was not a leap year)
  const excelEpoch = new Date(1899, 11, 30); // December 30, 1899
  const jsDate = new Date(
    excelEpoch.getTime() + excelSerial * 24 * 60 * 60 * 1000
  );
  return jsDate;
};

/**
 * Helper function to get field value from any fields array by EntityMetaType
 * This is a more generic version that works with any field structure
 * @param {Array} fields - Array of fields with EntityMetaType and EntityMetaValue
 * @param {string} fieldType - The EntityMetaType to search for
 * @returns {*} The EntityMetaValue of the found field, or null if not found
 */
const getFieldValue = (fields, fieldType) => {
  if (!fields || !Array.isArray(fields)) {
    return null;
  }

  const field = fields.find((f) => f.EntityMetaType === fieldType);
  return field ? field.EntityMetaValue : null;
};

/**
 * Helper function to update field value in fields array by EntityMetaType
 * @param {Array} fields - Array of fields with EntityMetaType and EntityMetaValue
 * @param {string} fieldType - The EntityMetaType to update
 * @param {*} value - The new value to set
 * @returns {Array} New array with updated field value
 */
const updateFieldValue = (fields, fieldType, value) => {
  if (!fields || !Array.isArray(fields)) {
    return [];
  }

  return fields.map((field) =>
    field.EntityMetaType === fieldType
      ? { ...field, EntityMetaValue: value }
      : field
  );
};
/**
 * Sorts a Map based on the sortOrder property of corresponding columns in an array.
 *
 * This function takes a Map and an array of column definitions, then returns a new Map
 * with entries sorted according to the sortOrder property found in the columns array.
 * If a column doesn't have a sortOrder property, it's assigned Infinity, placing it at the end.
 *
 * @param {Map} mapA - The Map to be sorted, where keys correspond to column ids
 * @param {Array<Object>} sortedArray - Array of column objects containing id and sortOrder properties
 * @param {string} sortedArray[].id - The column identifier used to match Map keys
 * @param {number} [sortedArray[].sortOrder] - The sort order value; lower values appear first
 * @returns {Map} A new Map with entries sorted by the sortOrder values from sortedArray
 * */
const sortMap = (mapA, sortedArray) => {
  return new Map(
    Array.from(mapA).sort((a, b) => {
      const columnA = sortedArray.find((col) => col.id === a[0]);
      const columnB = sortedArray.find((col) => col.id === b[0]);
      const sortOrderA = columnA?.sortOrder ?? Infinity;
      const sortOrderB = columnB?.sortOrder ?? Infinity;
      return sortOrderA - sortOrderB;
    })
  );
};

/**
 * Removes the Geek location from the provided array of locations.
 * @param {Array} parents - Entity Locations
 * @returns {Array} Locations (Geek location removed)
 */
const excludeGeekStorage = (parents) => {
  let geekId = bake({ key: 'geekStorage' });
  return parents.filter((parent) => parent.Entity_DBID !== geekId);
};

/**
 * Fetches a template from the API based on the provided entity type.
 *
 * This function makes an asynchronous call to retrieve template data by invoking
 * the 'getTemplateByType' stored procedure with the specified entity type.
 *
 * @async
 * @function fetchTemplate
 * @param {Object} type - An object containing the entity type information
 * @param {string} type.EntityType - The specific entity type to fetch the template for
 * @returns {Promise<Array|null>} Returns an array of template data if found and non-empty,
 *                                 otherwise returns null. Also returns null if an error occurs.
 * @throws Will log an error to the console if the API call fails, but will not throw the error
 *
 * @example
 * const template = await fetchTemplate({ EntityType: 'Oscilloscope' });
 */
export async function fetchTemplate(type) {
  try {
    const response = await Api({
      sp: 'getTemplateByType',
      json: { type: type.EntityType },
    });
    if (Array.isArray(response) && response.length > 0) {
      return response;
    }
    return null;
  } catch (error) {
    console.error('Failed to fetch template:', error);
    return null;
  }
}

export {
  minHeight,
  handleResize,
  isNum,
  uploadError,
  groupSelectError,
  toastMsg,
  getComparator,
  formatHistoryResponse,
  isJson,
  clearCookies,
  getRoles,
  checkVersion,
  getEnvironment,
  setEnvironmentVariables,
  getNextSteps,
  oven,
  idleTimeout,
  clearStorage,
  bake,
  excelDateToJSDate,
  getFieldValue,
  updateFieldValue,
  sortMap,
  excludeGeekStorage,
};
